module.exports = __webpack_public_path__ + "static/media/71.cd9ee485.jpg";